import React from 'react';

import { Box } from 'components/ui';

import { getConfigValues } from '../utils';

import { HiddenEnvItem } from './env-item';
import { HiddenSection } from './hidden-section';

const ConfigSettingsContent = () => {
  return (
    <Box>
      {Object.entries(getConfigValues()).map(([key, value]) => (
        <HiddenEnvItem key={key} envKey={key} value={JSON.stringify(value)} />
      ))}
    </Box>
  );
};

export const ConfigSettings = () => (
  <HiddenSection title="Config Settings" content={<ConfigSettingsContent />} />
);
